import { html, unsafeCSS } from 'lit';
import { BaseElement, customElement } from '../../components';
import styles from './universal-user-dropdown-loader.scss?inline';

@customElement('ps-universal-user-dropdown-loader')
export class UniversalUserDropdownLoaderWC extends BaseElement {
  static styles = unsafeCSS(styles);

  render() {
    return html`<div class="c-universal-user-dropdown-loader"></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-universal-user-dropdown-loader': UniversalUserDropdownLoaderWC;
  }
  enum PSElementTagNameMap {
    'ps-universal-user-dropdown-loader' = 'ps-universal-user-dropdown-loader',
  }
}
